import React, { ChangeEvent, useEffect } from 'react';
import { EventOrValueHandler } from 'redux-form';
import Checkbox from './Checkbox';

type CheckboxInputProps = {
  input: { checked: boolean; onChange: EventOrValueHandler<ChangeEvent> };
  text?: string;
  initialValue?: boolean;
};

const CheckboxInput = ({
  input: { checked, onChange },
  text = '',
  initialValue = false,
  ...restProps
}: CheckboxInputProps) => {
  useEffect(() => {
    onChange(initialValue);
  }, [onChange, initialValue]);
  return (
    <Checkbox
      {...restProps}
      text={text}
      checked={checked}
      onChange={onChange}
    />
  );
};

export default CheckboxInput;
